// src/pages/Login.js
import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import { useNotification } from "../context/NotificationContext";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const Login = () => {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const navigate = useNavigate();
  const location = useLocation();
  const { showNotification } = useNotification();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_BASE_URL}/auth/login`,
        credentials
      );
      const { role, username } = response.data;

      // Stockage du rôle et du username dans le localStorage
      localStorage.setItem("username", username);
      localStorage.setItem("role", role);

      // Redirige vers la page de provenance (ex: shippig_payment) ou à défaut vers l'accueil
      const from = location.state?.from?.pathname || "/";
      navigate(from, { replace: true });
    } catch (error) {
      if (error.response) {
        const { message } = error.response.data;
        showNotification(message, 'error');
      } else {
        console.error("Erreur réseau ou serveur", error);
        showNotification("Une erreur est survenue. Veuillez réessayer.", 'error');
      }
    }
  };

  return (
    <div className="flex justify-center items-center py-12">
      <div className="bg-white border border-slate-200 p-8 rounded-xl shadow-sm w-full max-w-md">
        <h2 className="text-2xl font-bold mb-2 text-center text-slate-800">Connexion</h2>
        <p className="text-slate-500 text-sm text-center mb-6">Accédez à votre espace membre.</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">
              Nom d'utilisateur <span className="text-rose-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Ex: jdoe"
              value={credentials.username}
              onChange={(e) =>
                setCredentials({ ...credentials, username: e.target.value })
              }
              required
              className="w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-sm text-slate-800 placeholder-slate-400 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-none transition-all"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1">
              Mot de passe <span className="text-rose-500">*</span>
            </label>
            <input
              type="password"
              placeholder="••••••••"
              value={credentials.password}
              onChange={(e) =>
                setCredentials({ ...credentials, password: e.target.value })
              }
              required
              className="w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-sm text-slate-800 placeholder-slate-400 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-none transition-all"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2.5 rounded-lg text-sm transition-colors shadow-sm shadow-indigo-600/10 mt-6"
          >
            Se connecter
          </button>
        </form>

        <p className="text-slate-500 text-xs text-center mt-6">
          Pas encore inscrit ?{" "}
          <Link to="/register" className="text-indigo-600 hover:underline font-semibold">
            Créer un compte
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
